import SUPPORT from '../actionTypes';

import { AppAction } from '../../../types/app';
import { SupportState } from '../types';

const initialState: SupportState = {
  readyStatus: SUPPORT.SUPPORT.INVALID,
  err: null,
};

export default (
  state: SupportState = initialState,
  action: AppAction = {}
): SupportState => {
  switch (action.type) {
    case SUPPORT.SUPPORT.INVALID:
      return {
        ...state,
        err: null,
        readyStatus: action.type,
      };
    case SUPPORT.SUPPORT.REQUESTING:
      return {
        ...state,
        err: null,
        readyStatus: action.type,
      };
    case SUPPORT.SUPPORT.FAILURE:
      return {
        ...state,
        err: action.err,
        readyStatus: action.type,
      };
    case SUPPORT.SUPPORT.SUCCESS:
      return {
        ...state,
        err: null,
        readyStatus: action.type,
      };
    default:
      return state;
  }
};
